import axiosInstance from '../axiosInstance';

// Obtener todos los tipos de mantenimiento
export const fetchComponentTypes = async () => {
  const response = await axiosInstance.get('/maintenance/componentType');
  return response.data;
};

// Crear un tipo de mantenimiento
export const createComponentType = async (data) => {
  const response = await axiosInstance.post('/maintenance/componentType', data);
  return response.data;
};

// Actualizar un tipo de mantenimiento
export const updateComponentType = async (id, data) => {
  const response = await axiosInstance.put(`/maintenance/componentType/${id}`, data);
  return response.data;
};

// Eliminar un tipo de mantenimiento
export const deleteComponentType = async (id) => {
  const response = await axiosInstance.delete(`/maintenance/componentType/${id}`);
  return response.data;
};
